const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹'

/* Shows Latin digits as Persian digits, for numbers rendered inside Persian copy */
export const toPersianDigits = (value: number | string): string => {
    return String(value).replace(/[0-9]/g, digit => PERSIAN_DIGITS[Number(digit)])
}
